import { useCallback } from 'react';
import { useRsrc } from '@/common/rsrc/RsrcContext';

export const useCloneAndRun = () => {
  const rsrc = useRsrc();

  const cloneAndRun = useCallback(
    (jobId, entityIds, jobIdToApprover, partition) => {
      const reqParam = { jobId, entityIds, jobIdToApprover, partition };
      // Return the promise so that callers can chain .then() or use await
      return rsrc.store('skdr', 'JOB_CLONE_AND_RUN_STORE_PLUGIN', reqParam);
    },
    [rsrc]
  );

  return cloneAndRun;
};
